'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionCorrespondence', ['$scope', '$stateParams', '$state', 'Correspondences', 'EnterpriseMergeFields', '$q', 'MergeContactGroups', 'UserInspectors', 'MergeTemplates', 'MergeObjects', '$rootScope',
        function ($scope, $stateParams, $state, Correspondences, EnterpriseMergeFields, $q, MergeContactGroups, UserInspectors, MergeTemplates, MergeObjects, $rootScope) {
        $scope.resetInspection();
        $scope.correspondence = $stateParams.inspection_correspondence;
        $scope.correspondenceID = $stateParams.inspectionCorrespondenceID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.merge_fields = [];
        $scope.merge_objects = [];
        $scope.documents = [];
        $scope.inspectors = [];
        $scope.contact_groups = [];
        $scope.contacts = [];
        $scope.contactOptions = [];
        
        if ($stateParams.inspectionCorrespondenceID != null) {
            Correspondences.getByID($stateParams.inspectionCorrespondenceID).then(function (correspondence) {
                $scope.correspondence = correspondence;
                $scope.loading = false;
            })
        }
        else {
            $scope.correspondence = {};
            $scope.correspondence.to_address = [];
            $scope.correspondence.from_address = [];
            $scope.correspondence.cc_address = [];
            $scope.correspondence.bcc_address = [];
            $scope.correspondence.replyto_address = [];

            var a = EnterpriseMergeFields.get('Inspections').then(function (fields) {
                $scope.merge_fields = fields;
            });

            var b = UserInspectors.get().then(function (inspectors) {
                $scope.inspectors = inspectors;
            });

            var c = MergeContactGroups.get('Inspections').then(function (groups) {
                $scope.contact_groups = groups
            });

            var d = MergeTemplates.getInspectionTemplates().then(function (templates) {
                $scope.merge_templates = templates;
            });

            var e = MergeObjects.get('Inspections').then(function (objects) {
                $scope.merge_objects = objects;
            });

            $q.all([a, b, c, d, e]).then(function () {
                $scope.inspectors.forEach(function (inspector) {
                    if (inspector.user.email != null) {
                        $scope.contacts.push({ id: inspector.user.email, name: inspector.user.email, group: false });
                    }
                })
                $scope.contact_groups.forEach(function (group) {
                    $scope.contacts.push({ id: group.id, name: group.name, group: true });
                })
                $scope.contactOptions = angular.copy($scope.contacts);
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });          
        }

        $scope.setDocuments = function (correspondence) {
            $scope.documents = [];

            $scope.inspection.documents.forEach(function (document) {
                $scope.documents.push({ id: document.id, name: document.name });
            })

            if (correspondence.merge_template != null) {
                correspondence.merge_template.merge_documents.forEach(function (document) {
                    $scope.documents.push({ id: document.document_id, name: document.document_name });
                })
            }
        }

        $scope.$watch('inspectionLoading + loading', function () {
            if (!$scope.inspectionLoading && !$scope.loading) {
                $scope.setDocuments($scope.correspondence);
            }
        })

        $scope.save = function () {
            $scope.saving = true;
            $scope.correspondence.merge_entity_id = '23dc1895-6c49-4348-91f4-83217855c183';
            if ($rootScope.enterprise.settings.email_provider_enabled) {
                $scope.correspondence.from_address = [];
                $scope.correspondence.from_address.push({ id: $rootScope.enterprise.settings.email_provider_from_address, name: $rootScope.enterprise.settings.email_provider_from_address, group: false });
            };
            Correspondences.save($scope.correspondence, { inspectionID: $scope.inspectionID }).then(function (correspondence) {
                //updateArray($scope.inspection.correspondences, correspondence);
                //updateArray($scope.masterInspection.correspondences, correspondence);
                $scope.getInspection();
                $state.go('internal.inspecting.inspection.correspondences', { id: $scope.inspectionID });
                $scope.saving = false;
            });
        }
    }])
;